module.exports = __webpack_public_path__ + "12de9290aeff9eeb3545786b25aaff51.jpg";